"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Status = void 0;

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

var _tabs = _interopRequireDefault(require("antd/lib/tabs"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _TestkitRequestedTable = _interopRequireDefault(require("../../../components/testkit/TestkitRequestedTable"));

var _TestkitAwaitingResultTable = _interopRequireDefault(require("../../../components/testkit/TestkitAwaitingResultTable"));

var _TestkitNeedsReviewTable = _interopRequireDefault(require("../../../components/testkit/TestkitNeedsReviewTable"));

var _TestkitCompletedTable = _interopRequireDefault(require("../../../components/testkit/TestkitCompletedTable"));

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

require("./testkit.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Option
} = _select.default;
var Status;
exports.Status = Status;

(function (Status) {
  Status[Status["Requested"] = 0] = "Requested";
  Status[Status["AwaitingResult"] = 1] = "AwaitingResult";
  Status[Status["NeedsReview"] = 2] = "NeedsReview";
  Status[Status["Completed"] = 3] = "Completed";
})(Status || (exports.Status = Status = {}));

class TestKitsLandingPage extends _react.Component {
  constructor() {
    super(...arguments);

    this.handleTabChange = activeKey => {
      const {
        studyId
      } = this.props;
      this.props.history.push(`/study/${studyId}/testkits/${activeKey}`);
    };
  }

  render() {
    const {
      dashboardData
    } = this.props;
    const testkitSubpage = this.props.testkitSubpage === '' ? 'requested' : this.props.testkitSubpage;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "tab-bar"
    }, /*#__PURE__*/_react.default.createElement(_tabs.default, {
      defaultActiveKey: testkitSubpage,
      onChange: this.handleTabChange
    }, /*#__PURE__*/_react.default.createElement(_tabs.default.TabPane, {
      tab: `Requested (${dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.testkits.requestedCount})`,
      key: "requested"
    }, /*#__PURE__*/_react.default.createElement(_TestkitRequestedTable.default, null)), /*#__PURE__*/_react.default.createElement(_tabs.default.TabPane, {
      tab: `Awaiting Result (${dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.testkits.awaitingResultCount})`,
      key: "awaiting"
    }, /*#__PURE__*/_react.default.createElement(_TestkitAwaitingResultTable.default, null)), /*#__PURE__*/_react.default.createElement(_tabs.default.TabPane, {
      tab: `Needs Review (${dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.testkits.needsReviewCount})`,
      key: "needsreview"
    }, /*#__PURE__*/_react.default.createElement(_TestkitNeedsReviewTable.default, null)), /*#__PURE__*/_react.default.createElement(_tabs.default.TabPane, {
      tab: `Completed (${dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.testkits.completedCount})`,
      key: "completed"
    }, /*#__PURE__*/_react.default.createElement(_TestkitCompletedTable.default, null))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  studyId: selectors.getRequestedStudyId,
  testkitSubpage: selectors.getRequestedTestkitTab,
  dashboardData: selectors.getDashboardData
});

var _default = (0, _reactRedux.connect)(mapStateToProps, null)(TestKitsLandingPage);

exports.default = _default;